interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const UsdIcon = ({
  size = 24,
  width,
  height,
  fill = "#6CDE07",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.875 14.3655C16.875 16.293 15.3105 17.5725 13.0005 17.7653V19.5H11.418V17.748C9.85551 17.5718 8.37096 16.9717 7.125 16.0125L8.289 14.418C9.32625 15.2243 10.308 15.75 11.4908 15.9255V12.4905C8.835 11.8245 7.59825 10.8607 7.59825 8.88075C7.59825 6.9885 9.144 5.69175 11.418 5.51625V4.5H13.0005V5.5515C14.2373 5.68888 15.4165 6.14815 16.4205 6.8835L15.4012 8.5305C14.601 7.95225 13.7827 7.584 12.9277 7.40925V10.7385C15.693 11.4045 16.875 12.4732 16.875 14.3655ZM11.49 10.3702V7.28625C10.3447 7.374 9.74475 7.9875 9.74475 8.7585C9.74475 9.4935 10.0898 9.9675 11.4908 10.371L11.49 10.3702ZM14.7285 14.4877C14.7285 13.7002 14.346 13.227 12.9277 12.8235V15.996C14.0737 15.9075 14.7285 15.3293 14.7285 14.4885V14.4877Z"
        fill="white"
      />
    </svg>
  );
};

export default UsdIcon;
